import mapUnknownToString from 'unknown2string';
export default function mapUnknownToError(value) {
    if (value instanceof Error) {
        return value;
    }
    const message = mapUnknownToString(value);
    return new Error(message);
}
//# sourceMappingURL=map-unknown-to-error.js.map